import type React from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Switch,
  Typography,
} from "@mui/material";
import CustomTextField from "../../../../../components/ui/Textfield";
import type { PackageBuilderState } from "../types";

interface Props {
  state: PackageBuilderState;
  update: (patch: Partial<PackageBuilderState>) => void;
}

const brown = "#6b4226";

const PricingTab: React.FC<Props> = ({ state, update }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 3, maxWidth: 520 }}>
    <Box>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: 0.5,
          textTransform: "uppercase",
          mb: 0.75,
          color: "text.secondary",
        }}
      >
        Base Price (USD)
      </Typography>
      <CustomTextField
        type="number"
        placeholder="0"
        value={state.base_price}
        onChange={(e) => update({ base_price: e.target.value })}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
      />
    </Box>

    <FormControlLabel
      control={
        <Switch
          checked={state.is_active}
          onChange={(e) => update({ is_active: e.target.checked })}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": { color: brown },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: brown,
            },
          }}
        />
      }
      label="Active package"
    />

    <FormControlLabel
      control={
        <Checkbox
          checked={state.show_on_public}
          onChange={(e) => update({ show_on_public: e.target.checked })}
          sx={{ "&.Mui-checked": { color: brown } }}
        />
      }
      label="Show on public pricing page"
    />
  </Box>
);

export default PricingTab;
